import { render, staticRenderFns } from "./BerthInput.vue?vue&type=template&id=1139b53c"
import script from "./BerthInput.vue?vue&type=script&lang=js"
export * from "./BerthInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports